<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  [routerLink]="!disabled && !loading && routerLink ? routerLink : null"
  [queryParams]="queryParams"
  [queryParamsHandling]="queryParamsHandling"
  [attr.aria-label]="ariaLabel"
  [attr.aria-busy]="loading"
  (click)="onClick($event)"
>
  @if (loading) {
    <svg
      role="img"
      aria-hidden="true"
      class="animate-spin w-4 h-4 shrink-0"
      [ngClass]="spinnerColorClass"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
    </svg>
  }
  <ng-content></ng-content>
</button>
